module.exports = __webpack_public_path__ + "static/media/image-card-6.f9a81ff9.png";